import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

import Modal from 'common/components/modals/Modal';
import CommitmentText from 'components/CommitmentText';

export default class CommitmentDetailsModal extends React.Component {
  render() {
    const { isOpen, toggleModal } = this.props;

    return (
      <>
        <a
          onClick={() => toggleModal(true)}
          className="label product-information__header__price__details"
        >
          <TranslatedMessage id={'cart.commitment_details_modal.details'} />
        </a>
        <Modal isOpen={isOpen} onRequestClose={() => toggleModal(false)}>
          <CommitmentText {...this.props} />
        </Modal>
      </>
    );
  }
}
